import { WorkflowStatusActions } from "../../../utilities/enums/WorkflowStatusActions";
import { WorkflowStatuses } from "../../../utilities/enums/WorkflowStatuses";
import CustomButton from "../../stateless/customButton/CustomButton";
import { useStatusActionsController } from "./statusActionsController";
import { Loader } from "@progress/kendo-react-indicators";

interface IStatusActions {
  statusId: number;
  filingId: number;
  getStatus: Function;
  confirmAdvance?: boolean;
  toggleConfirmationDialog?: Function;
  setStatusActionId?: Function;
}

const StatusActions = (props: IStatusActions) => {
  const {
    statusId,
    filingId,
    getStatus,
    confirmAdvance,
    toggleConfirmationDialog,
    setStatusActionId,
  } = props;

  const {
    statusActions,
    onActionClick,
    rejectReasons,
    fetchingStatusActions,
    promulgate,
    isDevUser,
  } = useStatusActionsController(statusId, confirmAdvance, setStatusActionId, toggleConfirmationDialog, filingId, getStatus);

  // all status actions where a reason must be provided for the action
  const dropdownStatusActionIds = [
    WorkflowStatusActions.AGReject,
    WorkflowStatusActions.AGReturnToAgency,
    WorkflowStatusActions.GPROReject,
    WorkflowStatusActions.GPROReturnToAgency,
    WorkflowStatusActions.GPROReturnEmergencyFilingToAgency,
    WorkflowStatusActions.SOSNotifyAgencyOfChanges,
    WorkflowStatusActions.NonSubstantiveSOSNotifyAgencyOfChanges,
    WorkflowStatusActions.EmergencySOSNotifyAgencyOfChanges,
  ]

  return (
    <div>
      <p><b>Filing Actions</b></p>
      {fetchingStatusActions ? (
        <Loader type="infinite-spinner"/>
      ) : (
        <div>
          {statusId === WorkflowStatuses.ReadyForPromulgation && isDevUser && (
            <CustomButton
              title={'Promulgate (dev testing only)'}
              onClick={() => {promulgate(filingId)}}
              fillMode='outline'
            >
              Promulgate (dev testing only)
            </CustomButton>
          )}
          {statusActions.length > 0 ?
            statusActions.map((statusAction: any, index: number) => {
              return (
                <div style={{display:'flex', flexDirection:'column'}}>
                  {(!dropdownStatusActionIds.includes(statusAction.id) || rejectReasons.length > 0) && (
                    <CustomButton
                      key={index + statusAction.id}
                      title={statusAction.displayName}
                      onClick={() => {onActionClick(statusAction.id)}}
                      fillMode='outline'
                      isDropdown={dropdownStatusActionIds.includes(statusAction.id)}
                      dropdownChildren={rejectReasons}
                      onDropdownChildClick={async (e) => {
                        let child = e.item;
                        onActionClick(statusAction.id, child.id);
                      }}
                      dropdownChildTextField="rejectReason"
                    >
                      {statusAction.displayName}
                    </CustomButton>
                  )}
                  <div style={{marginLeft:'10px', marginBottom: '10px', display:'flex', alignItems:'center', fontStyle: 'italic'}}>
                    {" ".concat(statusAction.actionDescription)}
                  </div>
                </div>
              )
            })
            : 'There are no available actions at this time.'}
        </div>
      )}
    </div>
  )
}

export default StatusActions;